import './styles/app.css';
import { renderCourse } from './core/course-shell';
import { loadMathJax } from './core/optional-libraries';
import { subjects } from './courses/registry';
import type { CourseDefinition, SubjectEntry } from './types/course';

const app = document.querySelector<HTMLElement>('#app');
if (!app) throw new Error('缺少 #app 根节点');
let activeCourse: CourseDefinition | undefined;

function navigate(path: string): void {
  history.pushState({}, '', path);
  void route();
}

function renderHome(): void {
  document.title = '课堂课程｜选择入口';
  app!.innerHTML = `<main class="picker"><header class="picker-header"><div class="eyebrow">课堂网页课程</div><h1>选择学习方向</h1><p class="lead">先选择入口，再进入本节课程。每个页面都为课堂投屏留出清晰的思考空间。</p></header><div class="course-grid">${subjects.filter((subject) => subject.status === 'published').map((subject) => `<a class="course-card" href="/${subject.id}" data-nav><strong>${subject.subject}</strong><span>${subject.summary}</span><em>进入课程目录</em></a>`).join('')}</div></main>`;
}

function renderSubject(subject: SubjectEntry): void {
  document.title = `${subject.subject}｜选择课程`;
  const visibleModules = subject.modules.filter((module) => module.status !== 'archived');
  app!.innerHTML = `<main class="picker"><header class="picker-header"><a class="level-back" data-nav href="/">← 返回首页</a><div class="eyebrow">${subject.subject}</div><h1>选择课程</h1><p class="lead">${subject.summary}</p></header><div class="course-grid">${visibleModules.map((module) => {
    if (module.status !== 'published') {
      return `<div class="course-card course-card-placeholder" aria-disabled="true"><strong>${module.title}</strong><span>${module.summary}</span><em>建设中</em></div>`;
    }
    const href = module.href ?? `/${subject.id}/${module.id}`;
    return `<a class="course-card" href="${href}"${module.href ? '' : ' data-nav'}><strong>${module.title}</strong><span>${module.summary}</span><em>进入课程</em></a>`;
  }).join('')}</div></main>`;
}

async function renderModule(subject: SubjectEntry, moduleId: string): Promise<void> {
  const entry = subject.modules.find((module) => module.id === moduleId);
  if (!entry) return navigate(`/${subject.id}`);
  if (entry.href) {
    location.assign(entry.href);
    return;
  }
  if (!entry.load) return navigate(`/${subject.id}`);
  app!.innerHTML = '<div class="loading">正在进入课程…</div>';
  const loaded = await entry.load();
  activeCourse = loaded.default;
  document.title = `${activeCourse.title}｜${subject.subject}`;
  if (activeCourse.subjectId === 'maths') await loadMathJax();
  await renderCourse(app!, activeCourse);
}

async function route(): Promise<void> {
  await activeCourse?.unmount?.();
  activeCourse = undefined;
  document.onkeydown = null;
  const [subjectId, moduleId] = location.pathname.split('/').filter(Boolean);
  if (!subjectId) return renderHome();
  const subject = subjects.find((item) => item.id === subjectId);
  if (!subject) return renderHome();
  if (!moduleId) return renderSubject(subject);
  await renderModule(subject, moduleId);
}

app.addEventListener('click', (event) => {
  const link = (event.target as HTMLElement).closest<HTMLElement>('[data-nav]');
  const href = link?.getAttribute('href');
  if (!href) return;
  event.preventDefault();
  navigate(href);
});
window.addEventListener('popstate', () => void route());
void route();
